export default __webpack_public_path__ + "static/media/BTCB.7eed2744.svg";